import { render, staticRenderFns } from "./Recibircajas.vue?vue&type=template&id=721e92c5&"
import script from "./Recibircajas.vue?vue&type=script&lang=js&"
export * from "./Recibircajas.vue?vue&type=script&lang=js&"
import style0 from "./Recibircajas.vue?vue&type=style&index=0&id=721e92c5&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports